var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('AppBar-MenuWithActivator',{attrs:{"button-props":{
		text: _vm.text,
	},"submenu-style":_vm.submenuStyle,"width-style":_vm.widthStyle,"transparent":_vm.transparent,"link":_vm.item.url}},[(!_vm.item.disableTitle)?_c('CategoriesMegaMenu-CategoryTitle',{attrs:{"item":_vm.item}}):_vm._e(),_c('CategoriesMenu',{attrs:{"items":_vm.item.ordered,"link":_vm.item.dropdownImgLink}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }